import groundingIcon from '../assets/images/modules/grounding.png';
import anxietyIcon from '../assets/images/modules/anxiety.png';
import depressionIcon from '../assets/images/modules/depression.png';
import sleepIcon from '../assets/images/modules/sleep.png';
import moveIcon from '../assets/images/modules/gym.png';
import accountabilityIcon from '../assets/images/modules/accountability.png';

/** Explore modules: labels and order match noor-app APP_CONFIG (launch modules). */
export const exploreModules = [
  { id: 'grounding', label: 'Grounding', icon: groundingIcon },
  { id: 'anxiety', label: 'Anxiety Management', icon: anxietyIcon },
  { id: 'depression', label: 'Depression Resources', icon: depressionIcon },
  { id: 'move-restore', label: 'Move & Restore', icon: moveIcon },
  { id: 'accountability', label: 'Accountability', icon: accountabilityIcon },
  { id: 'sleep', label: 'Sleep Enhancement', icon: sleepIcon },
];
